import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE || 'http://localhost:3000'
});

export async function listSkins({ q = '', tag = '', page = 1, limit = 60 } = {}) {
  const res = await api.get('/webtool/skins', {
    params: { q, tag, page, limit },
  });
  return res.data; // {items,page,limit,total,totalPages}
}

export async function createSkin(formData) {
  const res = await api.post('/webtool/skins', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return res.data;
}

export async function updateSkin(id, formData) {
  const res = await api.put(`/webtool/skins/${id}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return res.data;
}

export async function deleteSkin(id) {
  const res = await api.delete(`/webtool/skins/${id}`);
  return res.data;
}